// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: "Open in new window" opens the whole app again at a route, a second window that
// then navigates on its own (mail in one, a chat in the other). The desktop app opens a
// real app window (konvo_desktop `openAppWindow`); a browser opens a new browser window.
// Phones have one window, so the option is hidden there. Desktop builds from before this
// feature hide it too, rather than sending the link to the system browser.

import {isRailWindow} from '@app/features/konvo_rail/utils/RailWindow';
import {getElectronAPI, isElectron} from '@app/features/ui/utils/NativeUtils';

const CASCADE_OFFSET = 32;
// Read when asked, not at import: the menus that offer this load in node tests too.
const PHONE_USER_AGENT = /iPad|iPhone|iPod|Android/i;

export function canOpenNewWindow(): boolean {
	if (typeof window === 'undefined') return false;
	if (isElectron()) return typeof getElectronAPI()?.openAppWindow === 'function';
	return !PHONE_USER_AGENT.test(navigator.userAgent);
}

export function openInNewWindow(routePath: string): void {
	const api = getElectronAPI();
	if (api?.openAppWindow) {
		void api.openAppWindow(routePath);
		return;
	}
	if (isElectron()) return;
	const width = Math.min(window.outerWidth, window.screen.availWidth);
	const height = Math.min(window.outerHeight, window.screen.availHeight);
	const left = window.screenX + CASCADE_OFFSET;
	const top = window.screenY + CASCADE_OFFSET;
	window.open(routePath, '_blank', `noopener,width=${width},height=${height},left=${left},top=${top}`);
}

/** The page this window shows, for "New window" on the current page. The Rail has no page of its own. */
export function currentRoutePath(): string {
	if (isRailWindow()) return '/';
	const {pathname, search, hash} = window.location;
	return `${pathname}${search}${hash}`;
}
